import { render, staticRenderFns } from "./ShareTokenCard.vue?vue&type=template&id=0935e32a"
import script from "./ShareTokenCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShareTokenCard.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports